const ENERGY_LABEL_LEADS = {
  title: 'Lead etichettatura energetica',
  description: 'Panoramica dei lead per l’etichettatura energetica',
  searchPlaceholder: 'Cerca tra i lead …',
  emptyState: 'Nessun lead trovato.',
  importButton: 'Importa Excel',
  importError: 'Impossibile importare il file.',
  importEmpty: 'Il file non conteneva righe.',
  importSummary: 'Importate {imported} righe su {received}.',
  importRejected: 'Righe rifiutate:',
  importRow: 'Riga {row}',
  importErrors: {
    required: '{field} mancante',
    invalid: '{field} non è valido',
    // more precise than the generic wording, worth its own key
    organizationNumber_invalid:
      'Il numero di organizzazione deve avere 9 cifre',
  },
  importFields: {
    contactPerson: 'Referente',
    organizationNumber: 'Numero organizzazione',
    contactEmail: 'Email',
    contactPhone: 'Telefono',
    companyName: 'Nome azienda',
  },
  assignToMe: 'Assegna a me',
  assignToMeNeedsEnovaGuid:
    'Il tuo utente non ha un GUID personale Enova e non può quindi assegnarsi lead.',
  backToList: 'Torna ai lead',
  unassigned: 'Non assegnato',
  loadError: 'Impossibile caricare i lead.',
  assignError: 'Impossibile assegnare il lead.',
  notFound: 'Lead non trovato.',
  importNotImplemented: 'L’importazione Excel non è ancora implementata.',
  commentSaveError: 'Impossibile salvare la nota.',
  commentSaved: 'Nota salvata.',
  daysAgo: '{count} giorni fa',
  missingAddress: 'Indirizzo mancante',
  deleteConfirmTitle: 'Elimina lead',
  deleteConfirmMessage:
    'Vuoi davvero eliminare questo lead? L’operazione non è reversibile.',
  deleteError: 'Impossibile eliminare il lead.',
  archiveError: 'Impossibile archiviare il lead.',
  blockError: 'Impossibile bloccare il lead.',
  blockNotYours: 'Solo il consulente a cui è assegnato il lead può bloccarlo.',
  blockWrongStatus:
    'Un lead può essere bloccato solo mentre il sopralluogo è in corso.',
  archiveConfirmTitle: 'Archivia lead',
  archiveConfirmMessage:
    'Vuoi davvero archiviare questo lead? Verrà contrassegnato come archiviato e uscirà dai casi aperti.',
  archiveNotAllowed: 'Un lead completato non può essere archiviato.',
  assignWrongStatus:
    'Un lead può essere assegnato solo quando il suo stato è Modulo compilato, Assegnato a un consulente, Bloccato o Informazioni mancanti.',
  actions: {
    archive: 'Archivia',
    block: 'Blocca',
    unblock: 'Sblocca',
  },
  lifecycle: {
    title: 'Ciclo di vita',
    steps: {
      imported: 'Lead importato',
      created: 'Creato — modulo inviato al cliente',
      formCompleted: 'Cliente pronto — pronto per il consulente',
      inspectionStarted: 'Assegnato a un consulente',
      inspectionCompleted: 'Consulente completato',
      completed: 'Certificato energetico emesso',
    },
  },
  building: {
    title: 'Edificio',
    buildingNumber: 'Numero edificio',
    buildingType: 'Tipo di edificio',
    none: 'Nessun edificio è ancora collegato al lead.',
    open: 'Apri l’edificio',
  },
  energyLabel: {
    title: 'Etichetta energetica',
    grade: 'Classe energetica',
    issued: 'Emessa',
    openCertificate: 'Apri il certificato',
    complete: 'Completa il lead',
    completeHelp:
      'Imposta il lead come completato e invia il certificato energetico via e-mail al referente',
    completeError: 'Impossibile completare il lead.',
  },
  inspection: {
    title: 'Sopralluogo',
    name: 'Nome',
    date: 'Data del sopralluogo',
    readSubmitted: 'Leggi i dati inviati',
    open: 'Apri il sopralluogo',
    create: "Crea l'ispezione dell'edificio",
    createAgain: "Crea una nuova ispezione dell'edificio",
    noLead: 'Il lead non è stato caricato.',
    fixErrorsFirst: 'Correggere prima i {count} errori nei controlli sopra.',
    createHint:
      "L'ispezione viene creata dal modulo sopra, con valori standard dove il cliente non ha risposto.",
    created: "L'ispezione dell'edificio è stata creata.",
    noBuilding: 'Collega prima un edificio al lead.',
    noSubmission: 'Nessun modulo inviato è ancora collegato al lead.',
    createError: "Impossibile creare l'ispezione dell'edificio.",
    exists: "Un'ispezione dell'edificio per questo lead è appena stata creata.",
    filledCount: '{count} valori sono stati compilati con valori standard.',
  },
  filters: {
    allOpen: 'Tutte aperte',
    waitingCustomer: 'In attesa del cliente',
    readyForInspector: 'Pronto per il consulente',
    mine: 'Le mie pratiche',
    completed: 'Completati',
    stopped: 'Sospesi',
    archived: 'Archiviati',
  },
  columns: {
    contactPerson: 'Referente',
    organizationNumber: 'Numero organizzazione',
    address: 'Indirizzo',
    status: 'Stato',
    consultant: 'Consulente',
    created: 'Creato il',
    actions: 'Azione',
  },
  reminder: {
    send: 'Invia promemoria',
    sent: 'Promemoria inviato',
    help: 'Invia di nuovo il link del modulo con la stessa scadenza',
    noDeadline:
      'Questo lead non ha ancora una scadenza — invia prima la prima notifica',
    error: 'Impossibile inviare il promemoria.',
  },
  status: {
    imported: 'Importato',
    created: 'Creato',
    formCompleted: 'Modulo compilato',
    inspectionStarted: 'Assegnato a un consulente',
    inspectionCompleted: 'Sopralluogo completato',
    completed: 'Etichetta energetica emessa',
    blocked: 'Bloccato',
    notEnoughInformation: 'Informazioni mancanti',
    cancelled: 'Archiviato',
    unknown: 'Sconosciuto',
  },
  detail: {
    companyName: 'Nome azienda',
    internalComment: 'Nota interna',
    internalCommentPlaceholder: 'Visibile solo a noi, mai al cliente',
    contactSection: 'Dati di contatto',
    contactPerson: 'Referente',
    phone: 'Telefono',
    email: 'E-mail',
    companySection: 'Azienda',
    organizationNumber: 'Numero organizzazione',
    streetName: 'Via',
    houseNumber: 'Numero civico',
    houseLetter: 'Lettera',
    postalCode: 'CAP',
    city: 'Città',
    mpidsSection: 'ID punto di misura',
    noMpids: 'Nessun ID punto di misura registrato',
    status: 'Stato',
    formSection: 'Modulo cliente',
    formLink: 'Link da inviare al cliente',
    copyLink: 'Copia link',
    linkCopied: 'Link copiato.',
    formStatus: 'Stato del modulo',
    formNotStarted: 'Non ancora aperto',
    formDraft: 'In compilazione',
    formSubmitted: 'Inviato',
  },
};

export default ENERGY_LABEL_LEADS;
